import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import React from 'react';
import Overlay from 'react-overlays/Overlay';

const propTypes = {};

export const styles = require('./Tooltip-styles.module.scss');

const modifiers = {
  preventOverflow: {
    // more than the shake animation so the tooltip doesn't move
    // off-screen causing a scrollbar for a second
    padding: 10,
  },
  offset: {
    enabled: true,
    offset: '0, 5px',
  },
};
function Tooltip({
  show,
  theme,
  target,
  children,
  placement: plaaaaace = 'top',
  ...outerProps
}) {
  return (
    <Overlay
      flip
      show={show}
      placement={plaaaaace}
      modifiers={modifiers}
      target={target}
    >
      {({ placement = '', props, arrowProps }) => (
        <div
          {...outerProps}
          {...props}
          data-visible={show}
          className={classNames(
            styles.tooltip,
            styles[theme],
            show && styles.show,
            styles[placement.split('-')[0]],
          )}
        >
          <div {...arrowProps} className={styles.arrow} />
          <div className={styles.content}>{children}</div>
        </div>
      )}
    </Overlay>
  );
}

Tooltip.propTypes = propTypes;

export default Tooltip;
